import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: "szz-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    imports: [RouterLink]
})
export class SidebarComponent {
  @Input() isOpen = false;
  @Output() logout = new EventEmitter<void>();

  onLogout() {
    this.logout.emit();
  }
  downloadPdf(): void {
    globalThis.location.href =
      "/assets/docs/administracija-uporabnikov-prirocnik.pdf";
  }
}
